// /src/pages/admin/DashboardPage.tsx

import React from "react";
import { Link } from "react-router-dom";

export const DashboardPage = () => {
  return (
    <div>
      <h2>Welcome to the Admin Panel</h2>
      <p>Select an option below to manage your content:</p>

      <div style={{ display: "flex", gap: "2rem", marginTop: "2rem" }}>
        <div
          style={{
            flex: 1,
            border: "1px solid #ccc",
            padding: "1rem",
            borderRadius: "8px",
          }}
        >
          <h3>Projects</h3>
          <ul>
            <li>
              <Link to="/admin/projects">View All Projects</Link>
            </li>
            <li>
              <Link to="/admin/projects/new">Add New Project</Link>
            </li>
          </ul>
        </div>

        <div
          style={{
            flex: 1,
            border: "1px solid #ccc",
            padding: "1rem",
            borderRadius: "8px",
          }}
        >
          <h3>Artworks</h3>
          <ul>
            <li>
              <Link to="/admin/artworks">View All Artworks</Link>
            </li>
            <li>
              <Link to="/admin/artworks/new">Add New Artwork</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
